import { render, staticRenderFns } from "./AppBuildCRUD.vue?vue&type=template&id=04f7e4dc&"
import script from "./AppBuildCRUD.vue?vue&type=script&lang=js&"
export * from "./AppBuildCRUD.vue?vue&type=script&lang=js&"
import style0 from "./AppBuildCRUD.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports